import { useRef } from 'react';

import type { Meta, StoryFn } from '@storybook/react';
import type { WeekSelectorProps } from 'components/WeekSelector';

import { mockWeeks } from './mockdata';

import { WeekSelector } from 'components/WeekSelector';

const codeString = `<WeekSelector 
  weeks={Object-with-periodnumbers-with-array-of-weeks-in-period};
  currentPeriod?={number};
  defaultSelection?={number};
  weekPrefix={string};
  periodLabels={string[]};
  optionsHeader={string};
  onSelectWeek={(weeknumber: {number}) => void};
 />`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Molecules/WeekSelector',
  component: WeekSelector,
  argTypes: {
    onSelectWeek: {
      action: 'selected week',
      table: {
        disable: true,
      },
    },
    portalContainerRef: {
      table: {
        disable: true,
      },
    },
    optionContainerOffset: {
      table: {
        disable: true,
      },
    },
    currentPeriod: { table: { disable: true } },
    defaultSelection: { table: { disable: true } },
  },
  parameters: {
    inspectComponent: WeekSelector,
    codeString: codeString,
  },
} as Meta<WeekSelectorProps>;

const Template: StoryFn<WeekSelectorProps> = (args) => {
  const handleSelectWeek = (weekNumber: number) => {
    args.onSelectWeek(weekNumber);
  };

  return (
    <div
      style={{
        padding: '1rem',
        backgroundColor: '#EEE',
        display: 'flex',
        gap: '1rem',
        alignItems: 'flex-start',
        flexDirection: 'column',
      }}
    >
      <WeekSelector {...args} currentPeriod={1} onSelectWeek={handleSelectWeek} />
      <WeekSelector
        {...args}
        defaultSelection={45}
        currentPeriod={2}
        onSelectWeek={handleSelectWeek}
        optionsHeader="Kies een planning - Blok 2"
      />
      <WeekSelector
        {...args}
        defaultSelection={6}
        currentPeriod={3}
        onSelectWeek={handleSelectWeek}
        optionsHeader="Kies een planning - Blok 3"
      />
      <WeekSelector
        {...args}
        defaultSelection={13}
        currentPeriod={4}
        onSelectWeek={handleSelectWeek}
        optionsHeader="Kies een planning - Blok 4"
      />
      <WeekSelector
        {...args}
        defaultSelection={23}
        currentPeriod={5}
        onSelectWeek={handleSelectWeek}
        optionsHeader="Kies een planning - Blok 5"
      />
      <WeekSelector
        {...args}
        defaultSelection={28}
        currentPeriod={6}
        onSelectWeek={handleSelectWeek}
        optionsHeader="Kies een planning - Blok 6"
      />
      <WeekSelector
        {...args}
        defaultSelection={36}
        onSelectWeek={handleSelectWeek}
        optionsHeader="Kies een planning - Zomer"
      />
    </div>
  );
};

const defaultArgs: Partial<WeekSelectorProps> = {
  weeks: mockWeeks,
  weekPrefix: 'week',
  periodLabels: ['Blok 1', 'Blok 2', 'Blok 3', 'Blok 4', 'Blok 5', 'Blok 6', 'Zomer'],
  optionsHeader: 'Kies een planning - Blok 1',
};

export const WeekSelectorExample = Template.bind({});

WeekSelectorExample.args = {
  ...defaultArgs,
};

const TemplateWithRef: StoryFn<WeekSelectorProps> = (args) => {
  const handleSelectWeek = (weekNumber: number) => {
    args.onSelectWeek(weekNumber);
  };

  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={containerRef}
      style={{
        padding: '1rem',
        backgroundColor: '#EEE',
        display: 'flex',
        gap: '1rem',
        alignItems: 'flex-start',
        flexDirection: 'column',
      }}
    >
      <WeekSelector
        {...args}
        currentPeriod={1}
        onSelectWeek={handleSelectWeek}
        portalContainerRef={containerRef}
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        optionContainerOffset={[-200, -250]}
      />
      <WeekSelector
        {...args}
        defaultSelection={45}
        currentPeriod={2}
        onSelectWeek={handleSelectWeek}
        optionsHeader="Kies een planning - Blok 2"
        portalContainerRef={containerRef}
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        optionContainerOffset={[-200, -250]}
      />
      <WeekSelector
        {...args}
        defaultSelection={6}
        currentPeriod={3}
        onSelectWeek={handleSelectWeek}
        optionsHeader="Kies een planning - Blok 3"
        portalContainerRef={containerRef}
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        optionContainerOffset={[-200, -250]}
      />
    </div>
  );
};

export const InAPortal = TemplateWithRef.bind({});

InAPortal.args = {
  ...defaultArgs,
};
